import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { withI18nConsumer } from '@bingads-webui-react/i18n-context';
import { Header } from './header';
import { useAutoBiddingFac } from '../hooks';
import { AUTO_BIDDING_FEATURE_IDS } from '../constants';

const StepWrapperInternal = (props) => {
  const {
    coupon, children, onClose, i18n,
  } = props;
  const { getFormattedCurrencyValue } = useAutoBiddingFac(i18n);

  const formattedCouponValue = useMemo(() => getFormattedCurrencyValue(coupon.CouponValue), [coupon.CouponValue, getFormattedCurrencyValue]);

  const headerText = useMemo(() => {
    switch (coupon.FeatureId) {
      case AUTO_BIDDING_FEATURE_IDS.MAX_CLICKS:
        return i18n.getString(_TL_('Get {0} when you set a maximize clicks bid strategy')).replace('{0}', formattedCouponValue);
      case AUTO_BIDDING_FEATURE_IDS.MAX_CONVERSIONS:
        return i18n.getString(_TL_('Get {0} when you set a maximize conversions bid strategy')).replace('{0}', formattedCouponValue);
      default:
        return '';
    }
  }, [coupon.FeatureId, formattedCouponValue, i18n]);

  return (
    <>
      <Header text={headerText} onCloseButtonClick={onClose} />
      {children}
    </>
  );
};

StepWrapperInternal.propTypes = {
  children: PropTypes.node.isRequired,
  coupon: PropTypes.shape({
    CouponValue: PropTypes.number.isRequired,
    FeatureId: PropTypes.number.isRequired,
  }).isRequired,
  i18n: PropTypes.shape({
    getString: PropTypes.func.isRequired,
  }).isRequired,
  onClose: PropTypes.func.isRequired,
};

export const StepWrapper = withI18nConsumer(StepWrapperInternal);
